'use client';

import React from 'react';

interface TagProps {
  children: React.ReactNode;
  className?: string;
}

const Tag: React.FC<TagProps> = ({ children, className = '' }) => {
  return (
    <span className={`inline-block text-[13px] font-normal uppercase tracking-wide ${className}`}>
      {children}
    </span>
  );
};

export default Tag;
